//////////////////////////////////////////
//src/assets/scripts/top/page.js
//////////////////////////////////////////
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import lottie from 'lottie-web';
import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, FreeMode } from "swiper/modules";

gsap.registerPlugin(ScrollTrigger);

export default class PageJS {
    constructor(common) {
        this.common = common;
        this.BREAK_SP = 767;
        this._mvMovieResolved = false;
    }
    mq(type = "sp") {
        if (type === "sp") return `(max-width: ${this.BREAK_SP}px)`;
        if (type === "pc") return `(min-width: ${this.BREAK_SP + 1}px)`;
        return type;
    }

    init() {
        this._scrollRestore();
        this._mvLogoOnce();
        this._secMv();
        this._secMvMovie();
        this._secFeatures();
        this._secFeaturesSwiper();
        this._secFacility();
        this._secGallerySwiper();

        this.common.init();//common.jsはここでinitさせる


    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    // 途中リロード対策
    // ブラウザの自動スクロール復元を止め、load・フォント読込後にピン位置を再計算してから元の位置へ戻す
    _scrollRestore() {
        const KEY = "top:scrollY";

        if ("scrollRestoration" in history) history.scrollRestoration = "manual";

        window.addEventListener("pagehide", () => {
            try { sessionStorage.setItem(KEY, String(window.scrollY)); } catch (e) { }
        });

        const nav = performance.getEntriesByType("navigation")[0];
        const isRestore = nav && (nav.type === "reload" || nav.type === "back_forward");

        let y = 0;
        try {
            if (isRestore && !location.hash) y = parseInt(sessionStorage.getItem(KEY), 10) || 0;
            sessionStorage.removeItem(KEY);
        } catch (e) { }

        const loaded = document.readyState === "complete"
            ? Promise.resolve()
            : new Promise((resolve) => window.addEventListener("load", resolve, { once: true }));
        const fonts = document.fonts ? document.fonts.ready : Promise.resolve();

        Promise.all([loaded, fonts]).then(() => {
            // MVのピン生成（load_finish後の2rAF）を待ってから
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    ScrollTrigger.refresh();
                    if (!y) return;

                    if (this.common.lenis) {
                        this.common.lenis.scrollTo(y, { immediate: true, force: true });
                    } else {
                        window.scrollTo(0, y);
                    }
                    ScrollTrigger.update();
                });
            });
        });

        // 遅延読込の画像で高さが変わったら再計算
        let timer = null;
        document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            if (img.complete) return;
            img.addEventListener("load", () => {
                clearTimeout(timer);
                timer = setTimeout(() => ScrollTrigger.refresh(), 200);
            }, { once: true });
        });
    }

    _mvLogoOnce() {
        const mv = document.querySelector("#Mv_area");
        const img = mv?.querySelector(".logo img");

        if (!mv || !img) return;
        if (mv.classList.contains("is-done") || mv.classList.contains("is-animating")) return;

        mv.classList.add("is-animating");

        gsap.killTweensOf(img);

        gsap.fromTo(
            img,
            {
                autoAlpha: 0
            },
            {
                autoAlpha: 1,
                duration: 0.8,
                delay: 0.2,
                ease: "power2.out",
                overwrite: true,
                onComplete: () => {
                    mv.classList.remove("is-animating");
                    mv.classList.add("is-done");
                    gsap.set(img, { clearProps: "willChange" });
                }
            }
        );
    }

    _secMv_BK() {
        if (this._secMvBound) return;
        this._secMvBound = true;

        this._mvMM = this._mvMM || gsap.matchMedia();

        const initPc = () => {
        this._mvMM.add(this.mq("pc"), () => {
            const mv = document.querySelector("#Mv_area");
            if (!mv) return;

            const txtIn = mv.querySelector(".txt_area .in");
            const movie = mv.querySelector(".movie");
            const logo = mv.querySelector(".logo");

            if (!txtIn) return;

            const getMove = () => {
                return Math.max(0, txtIn.scrollHeight - window.innerHeight);
            };

            if (getMove() <= 0) return;

            const tl = gsap.timeline({
                scrollTrigger: {
                    id: "mvPin_pc",
                    trigger: mv,
                    start: "top top",
                    end: () => `+=${getMove()}`,
                    pin: true,
                    scrub: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                    refreshPriority: 2,
                    //pinReparent: true,
                }
            });

            tl.to(txtIn, {
                y: () => -getMove(),
                ease: "none"
            }, 0);

            // if (logo) {
            //     tl.to(logo, {
            //         opacity: 0,
            //         ease: "none"
            //     }, 0);
            // }

            if (movie) {
                tl.to(movie, {
                    opacity: 0.7,
                    ease: "none"
                }, 0);
            }

            return () => {
                tl.scrollTrigger?.kill();
                tl.kill();
                gsap.set(txtIn, { clearProps: "transform" });
                if (movie) gsap.set(movie, { clearProps: "opacity" });
                if (logo) gsap.set(logo, { clearProps: "opacity" });
            };
        });

        };


        
        const initSp = () => {
            this._mvMM.add(this.mq("sp"), () => {
                const mvPanels = gsap.utils.toArray(".mv_img_wrap");

                mvPanels.forEach((panel) => {
                    const innerpanel = panel.querySelector(".img");
                    if (!innerpanel) return;

                    const movie = innerpanel.querySelector(".movie");
                    const logo = document.querySelector("#Mv_area .logo");

                    ScrollTrigger.getAll().forEach((st) => {
                        if (st.vars?.trigger === panel) st.kill(true);
                    });

                    const getValues = () => {
                        const panelHeight = innerpanel.offsetHeight;
                        const windowHeight = window.innerHeight;
                        const difference = panelHeight - windowHeight;
                        const fakeScrollRatio =
                            difference > 0 ? difference / (difference + windowHeight) : 0;
                        return { panelHeight, windowHeight, difference, fakeScrollRatio };
                    };

                    const applyMargin = () => {
                        const { panelHeight, fakeScrollRatio } = getValues();
                        panel.style.marginBottom = fakeScrollRatio
                            ? `${panelHeight * fakeScrollRatio}px`
                            : "";
                    };

                    applyMargin();

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            id: "mvPin_sp",
                            trigger: panel,
                            start: "top top",
                            end: () => {
                                applyMargin();
                                const { fakeScrollRatio } = getValues();
                                return fakeScrollRatio
                                    ? `+=${innerpanel.offsetHeight}`
                                    : "bottom 20%";
                            },
                            pinSpacing: false,
                            pin: true,
                            scrub: true,
                            invalidateOnRefresh: true,
                            onRefreshInit: applyMargin,
                            onRefresh: applyMargin,
                        }
                    });

                    tl.to(innerpanel, {
                        y: () => {
                            const { difference } = getValues();
                            return difference > 0 ? -difference : 0;
                        },
                        ease: "none",
                        duration: 1
                    }, 0)
                        .to(logo, {
                            opacity: 0,
                            ease: "none"
                        }, '<')
                        ;

                    if (movie) {
                        tl.to(movie, {
                            opacity: 0.3,
                            ease: "none",
                            duration: 1
                        }, 0);
                    }
                });

                //ScrollTrigger.refresh(true);

                return () => {
                    gsap.utils.toArray(".mv_img_wrap").forEach((panel) => {
                        panel.style.marginBottom = "";
                    });
                };
            });
        };


        const run = () => {
            if (this._secMvDone) return;
            this._secMvDone = true;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    initPc();
                    initSp();
                });
            });
        };

        if (document.body.classList.contains("load_finish")) {
            run();
        } else {
            window.addEventListener("site:load-finish", run, { once: true });
        }


        // const run = () => {
        //     if (this._secMvDone) return;
        //     this._secMvDone = true;

        //     requestAnimationFrame(() => {
        //         requestAnimationFrame(() => {
        //             initPc();
        //             initSp();
        //         });
        //     });
        // };

        // if (window.__MV_READY__) {
        //     run();
        // } else {
        //     window.addEventListener("mv:ready", run, { once: true });
        // }

    }

    _secMv__現状() {
        if (this._secMvBound) return;
        this._secMvBound = true;

        this._mvMM = this._mvMM || gsap.matchMedia();

        const initPc = () => {
            this._mvMM.add(this.mq("pc"), () => {
                const mv = document.querySelector("#Mv_area");
                //const mv = document.querySelector(".mv_img_wrap");
                if (!mv) return;

                const txtIn = mv.querySelector(".txt_area .in");
                const movie = mv.querySelector(".movie");
                const logo = document.querySelector("#Mv_area .logo");

                if (!txtIn) return;

                const getMove = () => {
                    return Math.max(0, txtIn.scrollHeight - window.innerHeight);
                };

                if (getMove() <= 0) return;

                const tl = gsap.timeline({
                    scrollTrigger: {
                        id: "mvPin_pc",
                        trigger: mv,
                        start: "top top",
                        end: () => `+=${getMove()}`,
                        pin: true,
                        scrub: true,
                        //pinSpacing: true,
                        invalidateOnRefresh: true,
                        //anticipatePin: 1,
                        //invalidateOnRefresh: true,
                        //refreshPriority: 2,
                    }
                });

                tl.to(txtIn, {
                    y: () => -getMove(),
                    ease: "none"
                }, 0);

                if (logo) {
                    tl.to(logo, {
                        opacity: 0,
                        ease: "none"
                    }, 0);
                }

                if (movie) {
                    tl.to(movie, {
                        opacity: 0.7,
                        ease: "none"
                    }, 0);
                }

                return () => {
                    //tl.scrollTrigger?.kill();
                    //tl.kill();
                   // gsap.set(txtIn, { clearProps: "transform" });
                    //if (movie) gsap.set(movie, { clearProps: "opacity" });
                    //if (logo) gsap.set(logo, { clearProps: "opacity" });
                };
            });

        };



        const initSp = () => {
            this._mvMM.add(this.mq("sp"), () => {
                const mvPanels = gsap.utils.toArray(".mv_img_wrap");

                mvPanels.forEach((panel) => {
                    const innerpanel = panel.querySelector(".img");
                    if (!innerpanel) return;

                    const movie = innerpanel.querySelector(".movie");
                    const logo = document.querySelector("#Mv_area .logo");

                    ScrollTrigger.getAll().forEach((st) => {
                        if (st.vars?.trigger === panel) st.kill(true);
                    });

                    const getValues = () => {
                        const panelHeight = innerpanel.offsetHeight;
                        const windowHeight = window.innerHeight;
                        const difference = panelHeight - windowHeight;
                        const fakeScrollRatio =
                            difference > 0 ? difference / (difference + windowHeight) : 0;
                        return { panelHeight, windowHeight, difference, fakeScrollRatio };
                    };

                    const applyMargin = () => {
                        const { panelHeight, fakeScrollRatio } = getValues();
                        panel.style.marginBottom = fakeScrollRatio
                            ? `${panelHeight * fakeScrollRatio}px`
                            : "";
                    };

                    applyMargin();

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            id: "mvPin_sp",
                            trigger: panel,
                            start: "top top",
                            end: () => {
                                applyMargin();
                                const { fakeScrollRatio } = getValues();
                                return fakeScrollRatio
                                    ? `+=${innerpanel.offsetHeight}`
                                    : "bottom 20%";
                            },
                            pinSpacing: false,
                            pin: true,
                            scrub: true,
                            invalidateOnRefresh: true,
                            onRefreshInit: applyMargin,
                            onRefresh: applyMargin,
                        }
                    });

                    tl.to(innerpanel, {
                        y: () => {
                            const { difference } = getValues();
                            return difference > 0 ? -difference : 0;
                        },
                        ease: "none",
                        duration: 1
                    }, 0)
                        .to(logo, {
                            opacity: 0,
                            ease: "none"
                        }, '<')
                        ;

                    if (movie) {
                        tl.to(movie, {
                            opacity: 0.3,
                            ease: "none",
                            duration: 1
                        }, 0);
                    }
                });

                //ScrollTrigger.refresh(true);

                return () => {
                    gsap.utils.toArray(".mv_img_wrap").forEach((panel) => {
                        panel.style.marginBottom = "";
                    });
                };
            });
        };


        const run = () => {
            if (this._secMvDone) return;
            this._secMvDone = true;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    initPc();
                    initSp();
                });
            });
        };

        if (document.body.classList.contains("load_finish")) {
            run();
        } else {
            window.addEventListener("site:load-finish", run, { once: true });
        }


    }

    _secMv() {
        if (this._secMvBound) return;
        this._secMvBound = true;

        this._mvMM = this._mvMM || gsap.matchMedia();

        const initPc = () => {
            this._mvMM.add(this.mq("pc"), () => {
                const mv = document.querySelector("#Mv_area");
                //const mv = document.querySelector(".mv_img_wrap");
                if (!mv) return;

                const txtIn = mv.querySelector(".txt_area .in");
                const movie = mv.querySelector(".movie");
                const logo = document.querySelector("#Mv_area .logo");

                if (!txtIn) return;

                const getMove = () => {
                    return Math.max(0, txtIn.scrollHeight - window.innerHeight);
                };

                if (getMove() <= 0) return;

                const tl = gsap.timeline({
                    scrollTrigger: {
                        id: "mvPin_pc",
                        trigger: mv,
                        start: "top top",
                        end: () => `+=${getMove()}`,
                        pin: true,
                        scrub: true,
                        //pinSpacing: true,
                        invalidateOnRefresh: true,
                        //anticipatePin: 1,
                        //invalidateOnRefresh: true,
                        //refreshPriority: 2,

                        refreshPriority: 20,
                    }
                });

                tl.to(txtIn, {
                    y: () => -getMove(),
                    ease: "none"
                }, 0);

                if (logo) {
                    tl.to(logo, {
                        opacity: 0,
                        ease: "none"
                    }, 0);
                }

                if (movie) {
                    tl.to(movie, {
                        opacity: 0.7,
                        ease: "none"
                    }, 0);
                }

                return () => {
                    //tl.scrollTrigger?.kill();
                    //tl.kill();
                    // gsap.set(txtIn, { clearProps: "transform" });
                    //if (movie) gsap.set(movie, { clearProps: "opacity" });
                    //if (logo) gsap.set(logo, { clearProps: "opacity" });
                };
            });

        };



        const initSp = () => {
            this._mvMM.add(this.mq("sp"), () => {
                const mvPanels = gsap.utils.toArray(".mv_img_wrap");

                mvPanels.forEach((panel) => {
                    const innerpanel = panel.querySelector(".img");
                    if (!innerpanel) return;

                    const movie = innerpanel.querySelector(".movie");
                    const logo = document.querySelector("#Mv_area .logo");

                    ScrollTrigger.getAll().forEach((st) => {
                        if (st.vars?.trigger === panel) st.kill(true);
                    });

                    const getValues = () => {
                        const panelHeight = innerpanel.offsetHeight;
                        const windowHeight = window.innerHeight;
                        const difference = panelHeight - windowHeight;
                        const fakeScrollRatio =
                            difference > 0 ? difference / (difference + windowHeight) : 0;
                        return { panelHeight, windowHeight, difference, fakeScrollRatio };
                    };

                    const applyMargin = () => {
                        const { panelHeight, fakeScrollRatio } = getValues();
                        panel.style.marginBottom = fakeScrollRatio
                            ? `${panelHeight * fakeScrollRatio}px`
                            : "";
                    };

                    applyMargin();

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            id: "mvPin_sp",
                            trigger: panel,
                            start: "top top",
                            end: () => {
                                applyMargin();
                                const { fakeScrollRatio } = getValues();
                                return fakeScrollRatio
                                    ? `+=${innerpanel.offsetHeight}`
                                    : "bottom 20%";
                            },
                            pinSpacing: false,
                            pin: true,
                            scrub: true,
                            invalidateOnRefresh: true,
                            onRefreshInit: applyMargin,
                            onRefresh: applyMargin,
                        }
                    });

                    tl.to(innerpanel, {
                        y: () => {
                            const { difference } = getValues();
                            return difference > 0 ? -difference : 0;
                        },
                        ease: "none",
                        duration: 1
                    }, 0)
                        .to(logo, {
                            opacity: 0,
                            ease: "none"
                        }, '<')
                        ;

                    if (movie) {
                        tl.to(movie, {
                            opacity: 0.3,
                            ease: "none",
                            duration: 1
                        }, 0);
                    }
                });

                //ScrollTrigger.refresh(true);

                return () => {
                    gsap.utils.toArray(".mv_img_wrap").forEach((panel) => {
                        panel.style.marginBottom = "";
                    });
                };
            });
        };


        const run = () => {
            if (this._secMvDone) return;
            this._secMvDone = true;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    initPc();
                    initSp();
                });
            });
        };

        if (document.body.classList.contains("load_finish")) {
            run();
        } else {
            window.addEventListener("site:load-finish", run, { once: true });
        }


    }
    

    //MP4のみ
    _secMvMovie_BK() {
        const fallback = document.querySelector("#Mv_area .mv_fallback");
        const video = document.getElementById("mv_mp4");

        if (!video) return;

        video.addEventListener("playing", () => {
            if (fallback) {
                gsap.to(fallback, {
                    opacity: 0,
                    duration: 0.4,
                    ease: "power2.out"
                });
            }
        }, { once: true });
    }

    //VIMEOとdm
    _secMvMovie() {
        const fallback = document.querySelector("#Mv_area .mv_fallback");
        const vimeoEl = document.getElementById("mv_vimeo");
        const dummyVideo = document.getElementById("mv_mp4");

        if (!vimeoEl || !fallback) return;

        const t0 = performance.now();
        const ts = () => `[${((performance.now() - t0) / 1000).toFixed(2)}s]`;

        console.log(ts(), '[Vimeo] _secMvMovie start');

        const hideFallback = (reason) => {
            if (this._mvMovieResolved) return;
            this._mvMovieResolved = true;
            console.log(ts(), '[Vimeo] hideFallback:', reason);
            gsap.to(fallback, { opacity: 0, duration: 0.8, ease: "power2.out" });
        };

        const postToVimeo = (msg) => {
            console.log(ts(), '[Vimeo] postMessage →', msg);
            vimeoEl.contentWindow.postMessage(JSON.stringify(msg), 'https://player.vimeo.com');
        };

        const subscribeEvents = () => {
            postToVimeo({ method: 'addEventListener', value: 'play' });
            postToVimeo({ method: 'addEventListener', value: 'timeupdate' });
        };

        const onVimeoMsg = (e) => {
            if (e.source !== vimeoEl.contentWindow) return;
            let data;
            try { data = JSON.parse(e.data); } catch { return; }

            console.log(ts(), '[Vimeo] message ←', data);

            if (data.event === 'ready') {
                subscribeEvents();
                postToVimeo({ method: 'getPaused' });
            }
            if (data.event === 'play' || data.event === 'timeupdate') {
                hideFallback(data.event);
                window.removeEventListener('message', onVimeoMsg);
            }
            if (data.method === 'getPaused' && data.value === false) {
                hideFallback('getPaused=false');
                window.removeEventListener('message', onVimeoMsg);
            }
        };
        window.addEventListener('message', onVimeoMsg);

        console.log(ts(), '[Vimeo] immediate subscribeEvents + getPaused');
        subscribeEvents();
        postToVimeo({ method: 'getPaused' });

        setTimeout(() => hideFallback('timeout 30s'), 30000);

        if (dummyVideo) {
            dummyVideo.play().catch(() => {});
        }
    }

    _secFeatures_BK() {
        this._featuresMM?.revert();
        this._featuresMM = gsap.matchMedia();

        this._featuresMM.add(this.mq("pc"), () => {
            const section = document.querySelector("#Features_area .content_area_wrap");
            if (!section) return;

            const track = section.querySelector(".content_area");
            if (!track) return;

            let tween = null;
            let rebuildTimer = null;

            const getDistance = () => {
                const dist = track.scrollWidth - section.clientWidth;
                return Math.max(0, dist);
            };

            const build = () => {
                tween?.scrollTrigger?.kill();
                tween?.kill();

                gsap.set(track, { x: 0 });

                const distance = getDistance();
                if (distance <= 0) {
                    ScrollTrigger.refresh(true);
                    return;
                }

                tween = gsap.to(track, {
                    x: () => -getDistance(),
                    ease: "none",
                    scrollTrigger: {
                        id: "featuresHorizontal",
                        trigger: section,
                        pin: true,
                        pinType: "transform",
                        scrub: true,
                        start: "top 10%",
                        end: () => `+=${getDistance()}`,
                        invalidateOnRefresh: true,
                        anticipatePin: 1,
                    },
                });

                ScrollTrigger.refresh(true);
            };

            build();

            const onResize = () => {
                build();
            };
            window.addEventListener("resize", onResize);

            const observer = new MutationObserver(() => {
                clearTimeout(rebuildTimer);
                rebuildTimer = setTimeout(() => {
                    build();
                }, 200);
            });

            observer.observe(track, {
                childList: true,
                subtree: true,
                characterData: true,
            });

            return () => {
                clearTimeout(rebuildTimer);
                window.removeEventListener("resize", onResize);
                observer.disconnect();
                tween?.scrollTrigger?.kill();
                tween?.kill();
                gsap.set(track, { x: 0 });
            };
        });
    }


    _secFeatures() {
        this._featuresMM?.revert();
        this._featuresMM = gsap.matchMedia();

        this._featuresMM.add(this.mq("pc"), () => {
            const section = document.querySelector("#Features_area .content_area_wrap");
            if (!section) return;

            const track = section.querySelector(".content_area");
            if (!track) return;

            let tween = null;
            let rebuildTimer = null;

            const getDistance = () => {
                const dist = track.scrollWidth - section.clientWidth;
                return Math.max(0, dist);
            };

            const build = () => {
                tween?.scrollTrigger?.kill();
                tween?.kill();

                gsap.set(track, { x: 0 });

                const distance = getDistance();
                if (distance <= 0) {
                    ScrollTrigger.refresh(true);
                    return;
                }

                tween = gsap.to(track, {
                    x: () => -getDistance(),
                    ease: "none",
                    scrollTrigger: {
                        id: "featuresHorizontal",
                        trigger: section,
                        pin: true,
                        pinType: "transform",
                        scrub: true,
                        start: "top 10%",
                        end: () => `+=${getDistance()}`,
                        invalidateOnRefresh: true,
                        anticipatePin: 1,
                        // 作り直しても下のトリガーより先に計算させる（MV=20 の次）
                        refreshPriority: 10,
                    },
                });

                ScrollTrigger.refresh(true);
            };

            build();

            const onResize = () => {
                build();
            };
            window.addEventListener("resize", onResize);

            const observer = new MutationObserver(() => {
                clearTimeout(rebuildTimer);
                rebuildTimer = setTimeout(() => {
                    build();
                }, 800);
            });

            observer.observe(track, {
                childList: true,
                subtree: true,
                //characterData: true,
            });

            return () => {
                clearTimeout(rebuildTimer);
                window.removeEventListener("resize", onResize);
                observer.disconnect();
                tween?.scrollTrigger?.kill();
                tween?.kill();
                gsap.set(track, { x: 0 });
            };
        });
    }

 


    _secFeaturesSwiper() {
        const el = document.querySelector(".feature_swiper");
        if (!el) return;

        let swiper = null;
        const mq = window.matchMedia(this.mq("sp"));

        const initSwiper = () => {
            if (swiper) return;

            swiper = new Swiper(el, {
                modules: [Scrollbar, Mousewheel],
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,
                freeMode: true,
                watchOverflow: true,
                scrollbar: {
                    el: el.querySelector(".feature_swiper-scrollbar"),
                    draggable: true,
                },
                mousewheel: {
                    forceToAxis: true,
                    sensitivity: 0.8,
                },
            });
        };

        const destroySwiper = () => {
            if (!swiper) return;

            swiper.destroy(true, true);
            swiper = null;
        };

        const check = () => {
            if (mq.matches) {
                initSwiper();
            } else {
                //initSwiper();
                destroySwiper();
            }
        };

        check();
        mq.addEventListener("change", check);
    }


    _secFacility() {
        const mm = gsap.matchMedia();

        mm.add(this.mq("sp"), () => {
            const els = gsap.utils.toArray("#Facility_area .top_menu_area .btn_anm_trigger");
            if (!els.length) return;

            els.forEach((el) => {
                ScrollTrigger.create({
                    trigger: el,
                    start: "top 60%",
                    end: "bottom top",
                    onEnter: () => el.classList.add("on"),
                    onLeave: () => el.classList.remove("on"),
                    onEnterBack: () => el.classList.add("on"),
                    onLeaveBack: () => el.classList.remove("on"),
                });
            });

            requestAnimationFrame(() => ScrollTrigger.refresh());
        });
    }

    _secGallerySwiper() {
        const el = document.querySelector(".gallery_swiper");
        if (!el) return;

        new Swiper(el, {
            modules: [Autoplay],
            //direction: "vertical",
            loop: true,
            //slidesPerView: 1,
            slidesPerView: "auto",
            speed: 40000,
            autoplay: {
                delay: 0,
            },
        });
    }
}